import * as React from 'react';
import { PlusIcon, MinusIcon, DirectionalArrow } from '@estee/elc-icons';
import { IconTypes } from '../constants/IconTypes';
import * as classnames from 'classnames';

export interface IAccordionIcons {
    iconType?: string;
    isOpen?: boolean;
    className?: string;
    collapseIconAriaLabel?: string;
    expandIconAriaLabel?: string;
}

export class AccordionIcons extends React.Component<IAccordionIcons> {
    constructor(props: IAccordionIcons) {
        super(props);
    }

    private getIconProps() {
        const isOpen = this.props.isOpen;

        return {
            'data-test-id': isOpen ? 'up_arrow_icon' : 'down_arrow_icon',
            className: isOpen
                ? classnames('elc-arrow-icon-up', ' js-arrow-icon-up', this.props.className)
                : classnames('elc-arrow-icon-down', 'js-arrow-icon-down', this.props.className),
            direction: isOpen ? 'top' : 'bottom'
        };
    }

    private getDefaultIcons() {
        const { collapseIconAriaLabel, expandIconAriaLabel } = this.props;
        const minusCss = classnames(
            'elc-accordion-minus-icon',
            'js-accordion-minus-icon',
            this.props.className
        );
        const plusCss = classnames(
            'elc-accordion-plus-icon',
            'js-accordion-plus-icon',
            this.props.className
        );

        return this.props.isOpen ? (
            <MinusIcon
                aria-label={collapseIconAriaLabel}
                data-test-id="minus_icon"
                className={minusCss}
            />
        ) : (
            <PlusIcon
                aria-label={expandIconAriaLabel}
                data-test-id="plus_icon"
                className={plusCss}
            />
        );
    }

    public render() {
        const arrowIconProps = this.getIconProps();

        return this.props.iconType && this.props.iconType === IconTypes.ARROW ? (
            <DirectionalArrow {...arrowIconProps} />
        ) : (
            this.getDefaultIcons()
        );
    }
}
